import type { TFunction } from "i18next";

/**
 * Converts a timestamp to a relative time string (e.g., "5m", "2h", "3d")
 * Uses i18n for localized suffixes
 */
export const formatTimeAgo = (timestamp: string, t: TFunction): string => {
	const now = new Date();
	const time = new Date(timestamp);
	const diffInMinutes = Math.floor(
		(now.getTime() - time.getTime()) / (1000 * 60),
	);

	if (diffInMinutes < 60) {
		return `${diffInMinutes} ${t("promoter_detail.activity.minutes")} ${t("promoter_detail.activity.ago")}`;
	} else if (diffInMinutes < 1440) {
		const hours = Math.floor(diffInMinutes / 60);
		return `${hours} ${t("promoter_detail.activity.hours")} ${t("promoter_detail.activity.ago")}`;
	} else {
		const days = Math.floor(diffInMinutes / 1440);
		return `${days} ${t("promoter_detail.activity.days")} ${t("promoter_detail.activity.ago")}`;
	}
};

export const getRelativeTime = (timestamp: string, t: TFunction): string => {
	const now = new Date();
	const date = new Date(timestamp);
	const diffInMinutes = Math.floor(
		(now.getTime() - date.getTime()) / (1000 * 60),
	);

	if (diffInMinutes < 1) return t("notifications.just_now");
	if (diffInMinutes < 60)
		return `${diffInMinutes}${t("notifications.minutes_ago")}`;

	const diffInHours = Math.floor(diffInMinutes / 60);
	if (diffInHours < 24) return `${diffInHours}${t("notifications.hours_ago")}`;

	const diffInDays = Math.floor(diffInHours / 24);
	if (diffInDays < 7) return `${diffInDays}${t("notifications.days_ago")}`;

	const diffInWeeks = Math.floor(diffInDays / 7);
	if (diffInWeeks < 4)
		return `${diffInWeeks}${t("notifications.weeks_ago", "sem")}`;

	return date.toLocaleDateString();
};
